import * as i0 from '@angular/core';
import { Pipe, NgModule } from '@angular/core';
import { DateTime, Duration } from 'luxon';
import { interval } from 'rxjs';

class DateTimeEarliestPipe {
    transform(value) {
        return (value == null ? null : DateTime.min(...value));
    }
}
DateTimeEarliestPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeEarliestPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DateTimeEarliestPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DateTimeEarliestPipe, name: "dateTimeEarliest" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeEarliestPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'dateTimeEarliest'
                }]
        }] });

class DateTimeFromFormatPipe {
    transform(value, format) {
        return (value == null ? null : DateTime.fromFormat(value, format));
    }
}
DateTimeFromFormatPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeFromFormatPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DateTimeFromFormatPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DateTimeFromFormatPipe, name: "dateTimeFromFormat" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeFromFormatPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'dateTimeFromFormat'
                }]
        }] });

class DateTimeFromHttpPipe {
    transform(value) {
        return (value == null ? null : DateTime.fromHTTP(value));
    }
}
DateTimeFromHttpPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeFromHttpPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DateTimeFromHttpPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DateTimeFromHttpPipe, name: "dateTimeFromHttp" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeFromHttpPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'dateTimeFromHttp'
                }]
        }] });

class DateTimeFromIsoPipe {
    transform(value) {
        return (value == null ? null : DateTime.fromISO(value));
    }
}
DateTimeFromIsoPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeFromIsoPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DateTimeFromIsoPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DateTimeFromIsoPipe, name: "dateTimeFromIso" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeFromIsoPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'dateTimeFromIso'
                }]
        }] });

class DateTimeFromJsDatePipe {
    transform(value) {
        return (value == null ? null : DateTime.fromJSDate(value));
    }
}
DateTimeFromJsDatePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeFromJsDatePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DateTimeFromJsDatePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DateTimeFromJsDatePipe, name: "dateTimeFromJsDate" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeFromJsDatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'dateTimeFromJsDate'
                }]
        }] });

class DateTimeFromMillisecondsPipe {
    transform(value) {
        return (value == null ? null : DateTime.fromMillis(value));
    }
}
DateTimeFromMillisecondsPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeFromMillisecondsPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DateTimeFromMillisecondsPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DateTimeFromMillisecondsPipe, name: "dateTimeFromMilliseconds" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeFromMillisecondsPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'dateTimeFromMilliseconds'
                }]
        }] });

class DateTimeFromRfc2822Pipe {
    transform(value) {
        return (value == null ? null : DateTime.fromRFC2822(value));
    }
}
DateTimeFromRfc2822Pipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeFromRfc2822Pipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DateTimeFromRfc2822Pipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DateTimeFromRfc2822Pipe, name: "dateTimeFromRfc2822" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeFromRfc2822Pipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'dateTimeFromRfc2822'
                }]
        }] });

class DateTimeFromSqlPipe {
    transform(value) {
        return (value == null ? null : DateTime.fromSQL(value));
    }
}
DateTimeFromSqlPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeFromSqlPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DateTimeFromSqlPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DateTimeFromSqlPipe, name: "dateTimeFromSql" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeFromSqlPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'dateTimeFromSql'
                }]
        }] });

class DateTimeLatestPipe {
    transform(value) {
        return (value == null ? null : DateTime.max(...value));
    }
}
DateTimeLatestPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeLatestPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DateTimeLatestPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DateTimeLatestPipe, name: "dateTimeLatest" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeLatestPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'dateTimeLatest'
                }]
        }] });

class DateTimeToFormatPipe {
    transform(value, format) {
        return (value == null ? null : value.toFormat(format));
    }
}
DateTimeToFormatPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToFormatPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DateTimeToFormatPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToFormatPipe, name: "dateTimeToFormat" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToFormatPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'dateTimeToFormat'
                }]
        }] });

class DateTimeToIsoDatePipe {
    transform(value) {
        return (value == null ? null : value.toISODate());
    }
}
DateTimeToIsoDatePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToIsoDatePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DateTimeToIsoDatePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToIsoDatePipe, name: "dateTimeToIsoDate" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToIsoDatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'dateTimeToIsoDate'
                }]
        }] });

class DateTimeToIsoTimePipe {
    transform(value) {
        return (value == null ? null : value.toISOTime());
    }
}
DateTimeToIsoTimePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToIsoTimePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DateTimeToIsoTimePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToIsoTimePipe, name: "dateTimeToIsoTime" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToIsoTimePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'dateTimeToIsoTime'
                }]
        }] });

class DateTimeToIsoWeekDatePipe {
    transform(value) {
        return (value == null ? null : value.toISOWeekDate());
    }
}
DateTimeToIsoWeekDatePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToIsoWeekDatePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DateTimeToIsoWeekDatePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToIsoWeekDatePipe, name: "dateTimeToIsoWeekDate" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToIsoWeekDatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'dateTimeToIsoWeekDate'
                }]
        }] });

class DateTimeToIsoPipe {
    transform(value) {
        return (value == null ? null : value.toISO());
    }
}
DateTimeToIsoPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToIsoPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DateTimeToIsoPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToIsoPipe, name: "dateTimeToIso" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToIsoPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'dateTimeToIso'
                }]
        }] });

class DateTimeToJsDatePipe {
    transform(value) {
        return (value == null ? null : value.toJSDate());
    }
}
DateTimeToJsDatePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToJsDatePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DateTimeToJsDatePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToJsDatePipe, name: "dateTimeToJsDate" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToJsDatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'dateTimeToJsDate'
                }]
        }] });

class DateTimeToLocalPipe {
    transform(value) {
        return (value == null ? null : value.toLocal());
    }
}
DateTimeToLocalPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToLocalPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DateTimeToLocalPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToLocalPipe, name: "dateTimeToLocal" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToLocalPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'dateTimeToLocal'
                }]
        }] });

class DateTimeToRelativePipe {
    constructor(ref) {
        this.ref = ref;
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = null;
        }
    }
    transform(value, unit, style) {
        if (value == null) {
            if (this.subscription) {
                this.subscription.unsubscribe();
                this.subscription = null;
            }
            return null;
        }
        if (!this.subscription) {
            this.subscription = interval(1000).subscribe(() => this.ref.markForCheck());
        }
        return value.toRelative({
            style,
            unit
        });
    }
}
DateTimeToRelativePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToRelativePipe, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Pipe });
DateTimeToRelativePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToRelativePipe, name: "dateTimeToRelative", pure: false });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToRelativePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'dateTimeToRelative',
                    pure: false
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; } });

class DateTimeToRelativeCalendarPipe {
    constructor(ref) {
        this.ref = ref;
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = null;
        }
    }
    transform(value, unit) {
        if (value == null) {
            if (this.subscription) {
                this.subscription.unsubscribe();
                this.subscription = null;
            }
            return null;
        }
        if (!this.subscription) {
            this.subscription = interval(1000).subscribe(() => this.ref.markForCheck());
        }
        return value.toRelativeCalendar({
            unit
        });
    }
}
DateTimeToRelativeCalendarPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToRelativeCalendarPipe, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Pipe });
DateTimeToRelativeCalendarPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToRelativeCalendarPipe, name: "dateTimeToRelativeCalendar", pure: false });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToRelativeCalendarPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'dateTimeToRelativeCalendar',
                    pure: false
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; } });

class DateTimeToSqlPipe {
    transform(value) {
        return (value == null ? null : value.toSQL());
    }
}
DateTimeToSqlPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToSqlPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DateTimeToSqlPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToSqlPipe, name: "dateTimeToSql" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToSqlPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'dateTimeToSql'
                }]
        }] });

class DateTimeToUtcPipe {
    transform(value) {
        return (value == null ? null : value.toUTC());
    }
}
DateTimeToUtcPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToUtcPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DateTimeToUtcPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToUtcPipe, name: "dateTimeToUtc" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DateTimeToUtcPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'dateTimeToUtc'
                }]
        }] });

class DurationFromIsoPipe {
    transform(value) {
        return (value == null ? null : Duration.fromISO(value));
    }
}
DurationFromIsoPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DurationFromIsoPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DurationFromIsoPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DurationFromIsoPipe, name: "durationFromIso" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DurationFromIsoPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'durationFromIso'
                }]
        }] });

class DurationFromIsoTimePipe {
    transform(value) {
        return (value == null ? null : Duration.fromISOTime(value));
    }
}
DurationFromIsoTimePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DurationFromIsoTimePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DurationFromIsoTimePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DurationFromIsoTimePipe, name: "durationFromIsoTime" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DurationFromIsoTimePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'durationFromIsoTime'
                }]
        }] });

class DurationFromMillisecondsPipe {
    transform(value) {
        return (value == null ? null : Duration.fromMillis(value));
    }
}
DurationFromMillisecondsPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DurationFromMillisecondsPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DurationFromMillisecondsPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DurationFromMillisecondsPipe, name: "durationFromMilliseconds" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DurationFromMillisecondsPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'durationFromMilliseconds'
                }]
        }] });

class DurationLongestPipe {
    transform(value) {
        return (value == null ? null : [...value].sort((a, b) => b.milliseconds - a.milliseconds)[0]);
    }
}
DurationLongestPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DurationLongestPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DurationLongestPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DurationLongestPipe, name: "durationLongest" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DurationLongestPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'durationLongest'
                }]
        }] });

class DurationShortestPipe {
    transform(value) {
        return (value == null ? null : [...value].sort((a, b) => a.milliseconds - b.milliseconds)[0]);
    }
}
DurationShortestPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DurationShortestPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DurationShortestPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DurationShortestPipe, name: "durationShortest" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DurationShortestPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'durationShortest'
                }]
        }] });

class DurationToFormatPipe {
    transform(value, format) {
        return (value == null ? null : value.toFormat(format));
    }
}
DurationToFormatPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DurationToFormatPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DurationToFormatPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DurationToFormatPipe, name: "durationToFormat" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DurationToFormatPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'durationToFormat'
                }]
        }] });

class DurationToHumanPipe {
    transform(value) {
        return (value == null ? null : value.toHuman());
    }
}
DurationToHumanPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DurationToHumanPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DurationToHumanPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DurationToHumanPipe, name: "durationToHuman" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DurationToHumanPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'durationToHuman'
                }]
        }] });

class DurationToIsoPipe {
    transform(value) {
        return (value == null ? null : value.toISO());
    }
}
DurationToIsoPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DurationToIsoPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DurationToIsoPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DurationToIsoPipe, name: "durationToIso" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DurationToIsoPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'durationToIso'
                }]
        }] });

class DurationToIsoTimePipe {
    transform(value) {
        return (value == null ? null : value.toISOTime());
    }
}
DurationToIsoTimePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DurationToIsoTimePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
DurationToIsoTimePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: DurationToIsoTimePipe, name: "durationToIsoTime" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: DurationToIsoTimePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'durationToIsoTime'
                }]
        }] });

/** @internal */
const PIPES = [
    DateTimeEarliestPipe,
    DateTimeFromFormatPipe,
    DateTimeFromHttpPipe,
    DateTimeFromIsoPipe,
    DateTimeFromJsDatePipe,
    DateTimeFromMillisecondsPipe,
    DateTimeFromRfc2822Pipe,
    DateTimeFromSqlPipe,
    DateTimeLatestPipe,
    DateTimeToFormatPipe,
    DateTimeToIsoDatePipe,
    DateTimeToIsoTimePipe,
    DateTimeToIsoWeekDatePipe,
    DateTimeToIsoPipe,
    DateTimeToJsDatePipe,
    DateTimeToLocalPipe,
    DateTimeToRelativePipe,
    DateTimeToRelativeCalendarPipe,
    DateTimeToSqlPipe,
    DateTimeToUtcPipe,
    DurationFromIsoPipe,
    DurationFromIsoTimePipe,
    DurationFromMillisecondsPipe,
    DurationLongestPipe,
    DurationShortestPipe,
    DurationToFormatPipe,
    DurationToHumanPipe,
    DurationToIsoPipe,
    DurationToIsoTimePipe
];
class LuxonModule {
}
LuxonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: LuxonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
LuxonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: LuxonModule, declarations: [DateTimeEarliestPipe,
        DateTimeFromFormatPipe,
        DateTimeFromHttpPipe,
        DateTimeFromIsoPipe,
        DateTimeFromJsDatePipe,
        DateTimeFromMillisecondsPipe,
        DateTimeFromRfc2822Pipe,
        DateTimeFromSqlPipe,
        DateTimeLatestPipe,
        DateTimeToFormatPipe,
        DateTimeToIsoDatePipe,
        DateTimeToIsoTimePipe,
        DateTimeToIsoWeekDatePipe,
        DateTimeToIsoPipe,
        DateTimeToJsDatePipe,
        DateTimeToLocalPipe,
        DateTimeToRelativePipe,
        DateTimeToRelativeCalendarPipe,
        DateTimeToSqlPipe,
        DateTimeToUtcPipe,
        DurationFromIsoPipe,
        DurationFromIsoTimePipe,
        DurationFromMillisecondsPipe,
        DurationLongestPipe,
        DurationShortestPipe,
        DurationToFormatPipe,
        DurationToHumanPipe,
        DurationToIsoPipe,
        DurationToIsoTimePipe], exports: [DateTimeEarliestPipe,
        DateTimeFromFormatPipe,
        DateTimeFromHttpPipe,
        DateTimeFromIsoPipe,
        DateTimeFromJsDatePipe,
        DateTimeFromMillisecondsPipe,
        DateTimeFromRfc2822Pipe,
        DateTimeFromSqlPipe,
        DateTimeLatestPipe,
        DateTimeToFormatPipe,
        DateTimeToIsoDatePipe,
        DateTimeToIsoTimePipe,
        DateTimeToIsoWeekDatePipe,
        DateTimeToIsoPipe,
        DateTimeToJsDatePipe,
        DateTimeToLocalPipe,
        DateTimeToRelativePipe,
        DateTimeToRelativeCalendarPipe,
        DateTimeToSqlPipe,
        DateTimeToUtcPipe,
        DurationFromIsoPipe,
        DurationFromIsoTimePipe,
        DurationFromMillisecondsPipe,
        DurationLongestPipe,
        DurationShortestPipe,
        DurationToFormatPipe,
        DurationToHumanPipe,
        DurationToIsoPipe,
        DurationToIsoTimePipe] });
LuxonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: LuxonModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: LuxonModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: PIPES,
                    exports: [PIPES]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { DateTimeEarliestPipe, DateTimeFromFormatPipe, DateTimeFromHttpPipe, DateTimeFromIsoPipe, DateTimeFromJsDatePipe, DateTimeFromMillisecondsPipe, DateTimeFromRfc2822Pipe, DateTimeFromSqlPipe, DateTimeLatestPipe, DateTimeToFormatPipe, DateTimeToIsoDatePipe, DateTimeToIsoPipe, DateTimeToIsoTimePipe, DateTimeToIsoWeekDatePipe, DateTimeToJsDatePipe, DateTimeToLocalPipe, DateTimeToRelativeCalendarPipe, DateTimeToRelativePipe, DateTimeToSqlPipe, DateTimeToUtcPipe, DurationFromIsoPipe, DurationFromIsoTimePipe, DurationFromMillisecondsPipe, DurationLongestPipe, DurationShortestPipe, DurationToFormatPipe, DurationToHumanPipe, DurationToIsoPipe, DurationToIsoTimePipe, LuxonModule };
